
export default class SsoLoginController {

	constructor (
		Sso,
		brands,
		$state,
		$filter
	) {
		// translations
		var translate = $filter('translate');
		this.translate = translate;

		// dependencies
		this.Sso = Sso;
		this.$state = $state;

		// outputs
		this.loading = false;
		this.logo = require('../../mangooid-logo.png');

		// inputs
		this.brands = brands;
		this.brand = brands[0];

		// proceed sso login
		if (this.$state.params.code) {
			this.ssoLogin();
		}

		// proceed authorize flow
		if (this.brands.length == 1) {
			this.authorizeFlow();
		}
	}

	authorizeFlow () {
		location.href = this.brand.authorizeUrl;
	}

	ssoLogin () {
		if (!this.loading) {
			this.loading = true;
			this.Sso.ssoLogin(
				this.$state.params.code,
				this.$state.params.state
			)
			.then(_ => {
				this.loading = false;
				this.$state.go('summaryPage', { stores: 'all' });
			})
			.catch(_ => {
				this.loading = false;
			})
			;
		}
	}

}

SsoLoginController.$inject = [
	'Sso',
	'brands',
	'$state',
	'$filter'
];



// WEBPACK FOOTER //
// ./src/page/ssoLogin/ssoLogin.controller.js